import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { Envelope } from '../stripeFeesQuery/types';
import { responseHandler } from '../utils';
import { AiUsageReport } from './types';

export const AI_USAGE_OVERVIEW_QUERY_KEY = 'ai-usage-overview';

export const useGetAiUsageOverview = (): UseQueryResult<AiUsageReport, AxiosError> => useQuery<
  AiUsageReport,
  AxiosError
>({
  queryKey: [AI_USAGE_OVERVIEW_QUERY_KEY],
  retry: 0,
  queryFn: async () => {
    const response = await axiosInstance.get<Envelope<AiUsageReport>>('/v3-getAiUsageOverview');
    return responseHandler(response).data;
  },
});
